var p={NONE:"0",XS:"2px",S:"4px",M:"8px",L:"16px",ROUNDED:"100vh",MAX:"100%"};export{p as default};
